import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = { url: String, category: String, mobile: Boolean, postcount: Number }
    static targets = ['column1', 'column2', 'column3']

    #position = 12;
    #entrys = 3; // Anzahl der Einträge/request
    #columnCount = 0;
    #loadAtStart = false;

    connect() {
        if (this.#loadAtStart) {
            this.loadMore();
        }
    }

    async loadMore() {
        let posts = {};
        let categorienames = {};
        const requestUrl = `${this.urlValue}/client/?per_page=${this.#entrys}&orderby=title&order=asc&acf_format=standard&offset=${this.#position}`;
        try {
            const response = await fetch(requestUrl);
            posts = await response.json();
        } catch (error) {
            console.error(error.message);
        }

        posts.forEach(async post => {
            categorienames[post.id] = '';
            const requestCategoryUrl = `${this.urlValue}/categories?post=${post.id}&per_page=100`;
            const getcategories = true;
            if (getcategories) {
                try {
                    await fetch(requestCategoryUrl)
                        .then(response => response.json())
                        .then(json => {
                            json.forEach(async category => {
                                if (category.link.includes("category/leistungen") && !category.link.endsWith("category/leistungen/")) {
                                    categorienames[post.id] += `<a href="${category.link}" class="bg-white rounded-xl font-normal leading-[160%] px-[13px] py-[2px] my-[3px] mr-[9px] whitespace-nowrap">${category.name}</a>`;
                                }
                            });
                        });
                } catch (error) {
                    console.error(error.message);
                }
            }

            let profileCard, link;
            const profile = {};
            profile.logoUrl = (typeof post.acf.quickinfo !== 'undefined' ? post.acf.quickinfo.kundenlogo.url : '');
            profile.brandColor = (post.acf.brandfarbe !== '' ? post.acf.brandfarbe : '#cd3232');
            profile.title = post.title.rendered;
            profile.description = post.excerpt.rendered;
            let array = post.acf.units;
            let stringUnits = "";
            if (array.length != 0) {
                for (let i = 0; i < array.length; i++) {
                    stringUnits = stringUnits + `<a href="${array[i].unit.guid}" class="bg-white rounded-xl font-normal leading-[160%] px-[13px] py-[2px] my-[3px] mr-[9px] whitespace-nowrap">${array[i].unit.post_title}</a>`
                }
            }
            
            if (post.acf.external_link == '') {
                link = `onclick="location.href='${post.link}'"`;
            } else {
                link = `onclick="window.open('${post.acf.external_link}', '_blank')"`;
            }

            if (this.mobileValue) {
                profileCard = `
                <div ${link} class="flex flex-col bg-primary px-[25px] py-[50px] items-start w-full" style="background-color:${profile.brandColor}">
                    <h3 class="text-white font-bold text-[36px]">${profile.title}</h3>
                    <div class="mt-[30px] text-left bg-white w-full rounded-3xl p-[18px] leading-[160%]">${profile.description}</div>
                    <h4 class="mt-[30px] text-white text-[26px]">Leistungen</h4>
                    <div class="flex flex-wrap">${stringUnits} ${categorienames[post.id]}</div>
                `;
                if (profile.logoUrl) {
                    profileCard += `
                        <div class="mt-[30px] p-[20px] w-full">
                            <img src="${profile.logoUrl}" class="w-3/4 mx-auto h-[100px] object-contain" alt="Logo: ${profile.title}" />
                        </div>
                    `;
                }
                profileCard += `
                </div>
                `;
                this.column1Target.innerHTML += profileCard;
            }
            else {
                profileCard = `
                <div ${link} class="flex flex-col bg-primary items-start rounded-3xl px-[27px] py-[44px] w-full cursor-pointer" style="background-color:${profile.brandColor}">
                    <h3 class="text-white font-bold">${profile.title}</h3>
                    <div class="mt-[27px] flex flex-wrap">${stringUnits} ${categorienames[post.id]}</div>
                    <div class="mt-[27px] text-left bg-white w-full rounded-3xl p-[18px] leading-[160%]">${profile.description}</div>
                `;
                if (profile.logoUrl) {
                    profileCard += `
                        <div class="mt-[27px] p-[18px] w-full">
                            <img src="${profile.logoUrl}" class="w-3/4 mx-auto h-[100px] object-contain" alt="Logo: ${profile.title}" />
                        </div>
                    `;
                }
                profileCard += `
                </div>
                `;
                switch (this.#columnCount) {
                    case 0:
                        this.column1Target.innerHTML += profileCard;
                        break;
                    case 1:
                        this.column2Target.innerHTML += profileCard;
                        break;
                    case 2:
                        this.column3Target.innerHTML += profileCard;
                        break;
                }
            }

            this.#columnCount++;
            if (this.#columnCount >= 3) {
                this.#columnCount = 0
            };
        });
        this.#position += this.#entrys;

        if (this.postcountValue <= this.#position) {
            const loadMore = document.querySelector('.unitOverviewLoadMore');
            loadMore.style.display = 'none';
        }
    }
}